import {
  Button,
  Flex,
  FlexProps,
  HStack,
  Icon,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FC } from 'react';
import { externalLinks } from 'app/api.config';
import AppStoreBadge from 'resources/images/mobile-app-store-badge.svg';
import GooglePlayStoreBadge from 'resources/images/google-play-store-badge.svg';
import { ReactComponent as CloseIcon } from 'resources/images/close-circle.svg';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setShowMobileNotification } from 'app/store/Settings/slice';
import { getShowMobileNotification } from 'app/store/Settings/selectors';

export const AppStoreNotification: FC<FlexProps> = (props) => {
  const dispatch = useAppDispatch();
  const showMobileNotification = useAppSelector(getShowMobileNotification);

  if (!showMobileNotification) {
    return null;
  }

  return (
    <Flex bg="B.20" borderRadius={8} p={2} direction="column" {...props}>
      <Icon
        data-testid="close-mobile-notification-button"
        onClick={() => dispatch(setShowMobileNotification(false))}
        as={CloseIcon}
        height="22px"
        width="22px"
        color="M.60"
        alignSelf="flex-end"
        _hover={{ color: 'M.70' }}
      />
      <VStack
        spacing={4}
        p={2}
        textAlign="center"
        data-testid="mobile-limit-notification-text"
      >
        <Text>
          Only Profile, Subscription and Settings can be managed in the mobile
          browser.
        </Text>
        <Text>
          For full functionality, head to the mobile app or sign in on your
          computer.
        </Text>
        <HStack spacing={4} pt={2}>
          <Button
            width={120}
            height={10}
            backgroundImage={`url(${AppStoreBadge})`}
            as={Link}
            href={externalLinks.mobileApp.IOS_APP_LINK}
            data-testid="mobile-limit-notification-app-store-link"
          />
          <Button
            width={135}
            height={10}
            backgroundImage={`url(${GooglePlayStoreBadge})`}
            as={Link}
            href={externalLinks.mobileApp.ANDROID_APP_LINK}
            data-testid="mobile-limit-notification-google-play-link"
          />
        </HStack>
      </VStack>
    </Flex>
  );
};
